<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpWidgetCard>
    <ItpBox
      alignItems="center"
      slot="header"
    >
      <strong>
        {{ 'General'|pgettext('Meter') }}
      </strong>
      <ItpButton
        :text="'Edit...'|gettext"
        variant="light"
        size="sm"
        class="ml-auto"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <BListGroup>
      <ItpLabeledListGroupItem
        :label="'Type'|pgettext('Meter')"
      >
        <ItpBox
          alignItems="center"
        >
          <ItpBadge
            no-box-shadow
            variant="light"
            class="mr-2"
          >
            <UcMeterTypeIcon
              :type="meter.meter_type"
            >
            </UcMeterTypeIcon>
            <ItpText
              :text="meter.meter_type|pgettext('MeterTypes', 'Sentence')"
              class="mx-2"
            >
            </ItpText>
          </ItpBadge>
          <ItpBadge
            :title="'Unit'|pgettext('Meter')"
            no-box-shadow
            variant="light"
            class="mx-2"
          >
            <ItpText
              :text="meter.unit"
              class="pl-2"
            >
            </ItpText>
          </ItpBadge>
          <ItpBadge
            :title="'Multiplier'|pgettext('Meter')"
            no-box-shadow
            variant="light"
            class="mx-2"
          >
            <ItpIcon
              name="fa-times"
            >
            </ItpIcon>
            <ItpText
              :text="meter.multiplier|number"
              class="pl-2"
            >
            </ItpText>
          </ItpBadge>
        </ItpBox>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Main meter'|pgettext('Meter')"
        v-if="meter.main_meter"
      >
        <UcCompactMeterDisplay
          :payload="meter.main_meter"
        >
        </UcCompactMeterDisplay>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Serial number'|pgettext('Meter')"
        :content="meter.serial_number"
        :helpTooltip="'The device\'s unique serial number.'|gettext"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Smart device'|pgettext('Meter')"
        :content="'Yes'|gettext"
        v-if="meter.smart_device"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Groups'|pgettext('Meter')"
        v-if="meter.groups && meter.groups.length"
      >
        <ItpBadge
          :key="name"
          :text="name"
          class="border border-gray-dark-900 mr-2"
          v-for="name in meter.groups"
        >
        </ItpBadge>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Status'|pgettext('Meter')"
      >
        <UcResourceStatusCard
          :resource="meter"
          @reload="evh_3818132362335583_reload($event, {})"
        >
        </UcResourceStatusCard>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Model name'|pgettext('Meter')"
        :content="meter.model_name"
        v-if="meter.model_name"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'DevEUI'|pgettext('Meter')"
        :content="meter.deveui"
        :helpTooltip="'64-bit globally-unique Extended Unique Identifier (EUI-64) assigned by the manufacturer, or the owner, of the end-device.'|gettext"
        v-if="meter.deveui"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Location Code'|pgettext('Meter')"
        :content="meter.tag_id"
        :helpTooltip="'Locally-unique tag ID to be used within the company.'|gettext"
        v-if="meter.tag_id"
      >
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Validity'|pgettext('Meter')"
      >
        <UcMeterValidityCard
          :item="meter"
        >
        </UcMeterValidityCard>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Site'|pgettext('Meter')"
        v-if="meter.site"
      >
        <ItpLink
          :to="{
    name: 'app.property',
    params: { id: meter.site.id }
  }"
        >
          {{ meter.site.name }}
<span :if="meter.site.description">- {{ meter.site.description }}</span>

        </ItpLink>
      </ItpLabeledListGroupItem>
      <ItpLabeledListGroupItem
        :label="'Description'|pgettext('Meter')"
        :content="meter.description"
        v-if="meter.description"
      >
      </ItpLabeledListGroupItem>
    </BListGroup>
  </ItpWidgetCard>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcMeterGeneralPanel extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  meter!: object;

  @Watch('meter')
  onMeter(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("meter")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_emit_9508_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8320016629450276_emit_9508, alias=undefined
    return {
      event: "saved",
      value: $event.data.modalResult.value,
    }
  }

  async evh_8320016629450276_close_9507_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_9507, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_8320016629450276_showModal_9506_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_9506, alias=undefined
    return {
      name: "MeterEditor",
      props: {
        meter: this.meter.editor(),
      }
      ,
    }
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3818132362335583_emit_9510_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_3818132362335583_emit_9510, alias=emitReload
    return {
      event: "reload",
    }
  }

  async evh_3818132362335583_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3818132362335583_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9504: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9503: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8320016629450276_emit_9508: actions.EmitAction;
    evh_8320016629450276_close_9507: actions.EventHandlerImpl;
    act_8320016629450276_showModal_9506: actions.ShowModalAction;
    evh_8320016629450276_clickPreventStop_9505: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_3818132362335583_emit_9510: actions.EmitAction;
    evh_3818132362335583_reload_9509: actions.EventHandlerImpl;
    evh_3818132362335583_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9504 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9503 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9504,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9503],
      }
    );
    const act_8320016629450276_emit_9508 = new actions.EmitAction(
      {
        actionArgs: this.act_8320016629450276_emit_9508_getActionArgs,
        events: [],
      }
    );
    const evh_8320016629450276_close_9507 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_emit_9508,
        event: "close",
        when: this.evh_8320016629450276_close_9507_getWhen,
        displayName: "emit",
      }
    );
    const act_8320016629450276_showModal_9506 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_9506_getActionArgs,
        events: [evh_8320016629450276_close_9507],
      }
    );
    const evh_8320016629450276_clickPreventStop_9505 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_9506,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_9505],
      }
    );
    const act_3818132362335583_emit_9510 = new actions.EmitAction(
      {
        actionArgs: this.act_3818132362335583_emit_9510_getActionArgs,
        displayName: "emitReload",
        events: [],
      }
    );
    const evh_3818132362335583_reload_9509 = new actions.EventHandlerImpl(
      {
        action: act_3818132362335583_emit_9510,
        event: "reload",
        displayName: "emitReload",
      }
    );
    const evh_3818132362335583_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_3818132362335583_reload_9509],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9504,
      evh_7315092382398562_reload_9503,
      evh_7315092382398562_reload,
      act_8320016629450276_emit_9508,
      evh_8320016629450276_close_9507,
      act_8320016629450276_showModal_9506,
      evh_8320016629450276_clickPreventStop_9505,
      evh_8320016629450276_clickPreventStop,
      act_3818132362335583_emit_9510,
      evh_3818132362335583_reload_9509,
      evh_3818132362335583_reload,
      emitReload: act_3818132362335583_emit_9510,
    }
  }
}

Vue.component("UcMeterGeneralPanel", UcMeterGeneralPanel);

</script>